<template>
	<v-snackbar v-model="shown"
				elevation="0"
				width="432"
				:timeout="timeout"
				style="position: initial; height: fit-content"
				:style="{ '--snack-bg': `${backgroundColor}26`, '--snack-color': backgroundColor.value }"
				:right="right">
		<div class="d-flex" :style="{ color: backgroundColor }">
			<rmp-icon v-if="icon" :src="icon" :color="backgroundColor" class="mr-3"></rmp-icon>
			{{ text }}
		</div>
		<template v-slot:action="{ attrs }">
			<rmp-btn icon="mdi-close" icon-size="24" :color="backgroundColor"
					 :tooltip="$tc('buttons.close')"
					 v-if="closable"
					 v-bind="attrs"
					 @click="close"/>
		</template>
	</v-snackbar>
</template>

<script setup lang="ts">
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { useAlert } from "@rmp/core/composables/useAlert";
import { ref, watch } from "vue";

export interface AlertProps {
	customBackgroundColor?: string;
	customIcon?: string;
	iconColor?: string;
	colorClass?: string;
	type?: string;
	text?: string;
	closable?: boolean;
	right?: boolean;
	timeout: number;
	icon?: string;
}

const props = withDefaults(defineProps<AlertProps>(), {
	closable: true,
	right: false
});

const { backgroundColor } = useAlert(props);

const shown = ref<boolean>(true);

const emit = defineEmits(["close"]);

const close = () => {
	emit("close");
};

watch(shown, (value) => {
	if(!value) {
		close();
	}
});
</script>

<style lang="less">
.v-snack {
  z-index: 9999 !important;
}

.v-snack__wrapper {
  min-width: unset;
  margin: 0;
  position: relative;
  background-color: white !important;
	
  &::after {
	  content: '';
	  position: absolute;
	  inset: 0;
	  background-color: var(--snack-bg);
	  border-radius: inherit;
	  pointer-events: none;
  }
}

.v-snack__action {
  margin-top: 8px;
  align-self: start;
}

.v-snack__content {
  padding-right: 8px;
}
</style>
